import { additional_colors } from '../additional-colors';
import { containedStyle, outlinedStyle, textStyle } from '../utils';
export function getButtonVariants(theme_colors) {
    return additional_colors.flatMap((color) => {
        return [
            {
                props: { color, variant: 'contained' },
                style: containedStyle(theme_colors[color]),
            },
            {
                props: { color, variant: 'outlined' },
                style: outlinedStyle(theme_colors[color]),
            },
            {
                props: { color, variant: 'text' },
                style: textStyle(theme_colors[color]),
            },
        ];
    });
}
export function getIconButtonVariants(theme_colors) {
    return additional_colors.flatMap((color) => {
        return [
            {
                props: { color, variant: 'text' },
                style: textStyle(theme_colors[color]),
            },
        ];
    });
}
